import $ from 'domtastic'
import gsap from 'gsap'

import { getRefs, getUtils } from '@js/components/_common/_Base'




/* TRANSITION: STEP SLIDE
---------------------------------------------------------------------------------------------------- */

export default {

    /* Rules
    --------------------------------------------------------- */

    // sync: true,
    name: 'StepSlide',
    from: { namespace: 'step' },
    to: { namespace: 'step' },




    /* Elements
    --------------------------------------------------------- */

    $utils: getUtils(),




    /* Intro
    --------------------------------------------------------- */

    once() {
        //
    },


    afterOnce() {
        //
    },




    /* Hooks
    --------------------------------------------------------- */

    beforeLeave({ current, next }) {
        this.$refs = getRefs(document.body, 'StepSlide')
        this.$nextRefs = getRefs(next.container, 'StepSlide')

        const indexData = this.$refs.slide[0].dataset.index.split('/')
        this.stepCount = parseInt(indexData[1], 10)
        this.currentIndex = parseInt(indexData[0], 10)
        this.nextIndex = parseInt(this.$nextRefs.slide[0].dataset.index.split('/')[0], 10)

        this.isForward = this.currentIndex < this.nextIndex
        this.$prevSlot = this.isForward ? this.$refs.prevSlot : this.$refs.nextSlot
        this.$nextSlot = this.isForward ? this.$refs.nextSlot : this.$refs.prevSlot


        // Append next slide content to relevant slot
        this.$nextSlot[0].innerHTML = this.$nextRefs.slide[0].innerHTML
        this.$nextSlotWrapper = this.$nextSlot[0].querySelector('.js-StepSlide-slideWrapper')


        // Append prev-1 / next+1 slot if necessary
        if (this.isForward && this.nextIndex < this.stepCount) {
            this.$extraSlot = $('<div class="stepSlot stepSlot--next | col-8 cf">')
            this.$extraSlot[0].style.transform = 'translate3d(170%,-400px,0) rotate(-8deg)'
        } else if (!this.isForward && this.nextIndex > 1) {
            this.$extraSlot = $('<div class="stepSlot stepSlot--prev | col-8 cf">')
            this.$extraSlot[0].style.transform = 'translate3d(-170%,300px,0) rotate(8deg)'
        }

        if (this.$extraSlot) {
            this.$refs.FX.append(this.$extraSlot)
        }


        // Get sizes
        this.sizes = {
            currentSlideH: this.$refs.slide[0].offsetHeight,
            nextSlideH: this.$nextSlot[0].offsetHeight,
        }
    },


    leave() {
        const done = this.async()
        const { isDesktop, scrollTop } = APP.Layout


        // GSAP doesn’t seem to understand “round” keyword in clip-path, so…
        const clip = { y: 0 }
        const slotClip = { y: this.sizes.nextSlideH - 700 }


        // Create Timeline
        this.TL = gsap.timeline({
            onComplete: done,
            defaults: {
                duration: 1.2,
                ease: 'power3.inOut',
            },
        })



        // Prev Slot
        const prevSlotX = this.isForward ? '-170%' : '170%'
        const prevSlotY = this.isForward ? 300 : -400
        const prevSlotR = this.isForward ? '-8deg' : '8deg'

        this.TL.to(this.$prevSlot, { x: prevSlotX, y: prevSlotY, rotate: prevSlotR }, 0)


        // Current Slide
        const currentSlideX = this.isForward ? '-120%' : '120%'
        const currentSlideY = this.isForward ? 150 + scrollTop : -200 + scrollTop
        const currentSlideR = this.isForward ? '4deg' : '-4deg'

        this.TL.to(clip, {
            y: this.sizes.currentSlideH - 700,
            onUpdate: () => {
                gsap.set(this.$refs.slide, {
                    webkitClipPath: `inset(0 0 ${clip.y}px 0 round 40px)`,
                    clipPath: `inset(0 0 ${clip.y}px 0 round 40px)`,
                })
            },
        }, 0.1)

        this.TL.to(this.$refs.slide, { x: currentSlideX, y: currentSlideY, rotate: currentSlideR, force3D: true }, 0.05)
        this.TL.to(this.$refs.slideWrapper, { alpha: 0, force3D: true }, 0.05)


        // Next Slot
        const nextSlotX = this.isForward ? '-50%' : '50%'

        this.TL.to(slotClip, {
            y: 0,
            onUpdate: () => {
                gsap.set(this.$nextSlot, {
                    webkitClipPath: `inset(0 0 ${slotClip.y}px 0 round 40px)`,
                    clipPath: `inset(0 0 ${slotClip.y}px 0 round 40px)`,
                })
            },
        }, 0.1)

        this.TL.to(this.$nextSlot, { x: nextSlotX, y: 0, rotate: '0deg', force3D: true }, 0.1)
        this.TL.to(this.$nextSlotWrapper, { alpha: 1, force3D: true }, 0.1)


        // Extra Slot
        if (this.$extraSlot) {
            const extraSlotX = this.isForward ? '70%' : '-70%'
            const extraSlotY = this.isForward ? -200 : 150
            const extraSlotR = this.isForward ? '-4deg' : '4deg'

            this.TL.to(this.$extraSlot, { x: extraSlotX, y: extraSlotY, rotate: extraSlotR, force3D: true }, 0.2)
        }


        // Star
        const nextRStep = this.isForward ? 1 : -1

        this.TL.to(this.$refs.star, { duration: 1.2, '--yProgress': 0, '--rStep': nextRStep }, 0)
    },


    beforeEnter({ next }) {
        const currGuideProgress = this.$refs.track[0].style.getPropertyValue('--guideProgress')
        this.$nextRefs.track[0].style.setProperty('--guideProgress', currGuideProgress)
    },


    enter() {
        // const done = this.async()
    },


    after() {
        this.$extraSlot = null
    },




    /* Actions
    --------------------------------------------------------- */

    //




    /* Values
    --------------------------------------------------------- */

}




/* HELPERS & CONSTANTS
---------------------------------------------------------------------------------------------------- */



